<template>
  <article class="Post-Alpha" :class="get_bgColor" @mouseenter="handleHover" ref="postElement">
    <DotUnread v-if="get_post.is_new"/>
    <transition name="Anim__opacity">
      <span class="Post-Alpha__moderation" v-if="!get_post.live">На модерации</span>
    </transition>
    <AlphaPostCover class="Post-Alpha__cover" :postId="props.postId" :post="get_post" @click="handleClick($event, true)"/>
    <a class="Post-Alpha__ttl-btn" :href="get_postUrl" target="_self" @click="handleClick">
      <PinIcon class="Post-Alpha__pin-icon" v-if="get_post.pinned_day" />
      <span class="Post-Alpha__ttl" v-html="get_post.title"></span>
    </a>
    <p 
      class="Post-Alpha__description" 
      v-if="get_post.short_description || get_post.seo_description"
    >
      {{ get_post.short_description  || get_post.seo_description}}
    </p>
    <AlphaPostInfo class="Post-Alpha__info" :post="get_post" :postId="props.postId"/>
    <PostMenu class="Post-Alpha__menu" :postId="props.postId" v-if="get_isShowMenu"/>
    <CommentLast
      class="Post-Alpha__comment"
      :count="get_post.comments_count"
      :postId="props.postId"
      :basicView="props.basicView"
      v-if="get_post.last_comment"
    />
  </article>
</template>

<script setup>
  import { computed, nextTick, ref, onMounted, onBeforeUnmount } from 'vue';
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';
  import { Props } from './scripts/props.js';
  import { POST_TYPES } from "@shared/constants/posts/postTypes";
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  import { observeOnce, unobserve } from '@shared/services/observers/intersectionObservers.js';
  //------------------------------------
  import PinIcon from '@svg/PinIcon.vue';
  import AlphaPostCover from './components/Cover/AlphaPostCover.vue';
  import AlphaPostInfo from './components/Info/AlphaPostInfo.vue';
  import PostMenu from '@entities/Posts/PostMenu/PostMenu.vue';
  import CommentLast from '@entities/Comments/CommentLast/CommentLast.vue';
  import DotUnread from "@entities/Posts/Components/DotUnread/DotUnread.vue";
  //------------------------------------
  const store = useStore();
  const route = useRoute();
  const props = defineProps(Props());
  //------------------------------------
  const postElement = ref(null);
  //------------------------------------
  let hoverTimer = null;
  let visibilityTimer = null;
  //------------------------------------
  onMounted(() => {
    if (!postElement.value || !get_post.value.is_new) return;
    const rect = postElement.value.getBoundingClientRect();
    const isVisible = (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom >= 0
    );

    if (isVisible) {
      handleVisibility();
    } else {
      observeOnce(postElement.value, handleVisibility);
    }
  });
  onBeforeUnmount(() => {
    if (postElement.value) {
      unobserve(postElement.value);
      postElement.value.removeEventListener('mouseenter', handleHover);
    }
    clearTimeout(visibilityTimer);
    clearTimeout(hoverTimer);
  });
  //------------------------------------
  //Получить пост
  const get_post = computed(() => store.state.ContentSystem.Alpha.list[props.postId]);
  //Подкаст ли это
  const get_isPodcast = computed(() => get_post.value.section_name === POST_TYPES.PODCAST);
  //Получить цвет фона поста
  const get_bgColor = computed(() => {
    if (get_post.value.live === false) {
      return `Post-Alpha--yellow`;
    } else if (get_post.value.is_new) {
      return `Post-Alpha--blue`;
    } else if (get_post.value.color) {
      return `Post-Alpha--${get_post.value.color}`
    }
  });
  //Пользователь не имеет доступа к закрытому контенту (нет платной подписки)
  const get_hasPaidAccess = computed(() => store.getters['UserSystem/hasPaidAccess']);
  //Отображать ли меню работы с постом
  const get_isShowMenu = computed(() => !props.hideMenu && get_hasPaidAccess.value);
  //Получить URL поста
  const get_postUrl = computed(() => `/${get_post.value.model_name.toLowerCase()}/${props.postId}`);
  //------------------------------------
  //Открыть попап с контентом, изменить адрес без перехода на страницу
  const toOpenContentPopup = async () => {
    store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.contentPage);
    await nextTick();
    toChangeUrl();
    store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.contentPage);
  };
  //Обработчик клика по заголовку
  const handleClick = (e, cover) => {
    //Если это подкаст и клик был по cover
    if (get_isPodcast.value && cover) {
      e.preventDefault();
      return;
    }
    //Если клик с `Ctrl`, `Meta`, `Shift`, или колесиком открывается новая вкладка
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1){
      window.open(get_postUrl.value, '_blank');
      return;
    }
    e.preventDefault();
    toOpenContentPopup();
  };
  //Обновить адрес в строке поиска и запомнить последний урл перед переходом
  const toChangeUrl = () => {
    store.commit('ContentSystem/toRememberLastPageUrl', route.path);
    window.history.pushState({}, '', window.location.href);
    window.history.replaceState({}, '', get_postUrl.value);
  };
  //Отмечаем, что пост прочитан
  const removeNewPostFlag = () => { store.commit('ContentSystem/Alpha/toUpdateNewStatus', props.postId) }

  const handleHover = () => {
    if(!get_post.value.is_new)return;
    removeNewPostFlag();
    clearTimeout(visibilityTimer);
    if (postElement.value) {
      unobserve(postElement.value);
    }
  };
  const handleVisibility = () => {
    if(!get_post.value.is_new)return;
    visibilityTimer = setTimeout(() => {
      removeNewPostFlag();
      unobserve(postElement.value);
    }, 5000);
  };
</script>

<style lang="scss">
  @import './styles/_conf';

</style>
